import filipposImg from "../img/profile_resized.png";
import iasonasImg from "../img/genealogy/iasonas.png";
import maragosImg from "../img/genealogy/maragos.png";
import schaferImg from "../img/genealogy/schafer.jpg";
import boseImg from "../img/genealogy/bose.jpg";
import wienerImg from "../img/genealogy/wiener.jpg";
import royceImg from "../img/genealogy/royce.jpg";
import morrisImg from "../img/genealogy/morris.png";
import trendelenburgImg from "../img/genealogy/trendelenburg.jpg";
import reinholdImg from "../img/genealogy/reinhold.jpg";
import kantImg from "../img/genealogy/kant.jpg";
import knutzenImg from "../img/genealogy/knutzen.jpg";
import wolffImg from "../img/genealogy/wolff.jpg";
import leibnizImg from "../img/genealogy/leibniz.jpg";
import huygensImg from "../img/genealogy/huygens.jpg";
import schootenImg from "../img/genealogy/schooten.jpg";
import goliusImg from "../img/genealogy/golius.jpg";
import snellImg from "../img/genealogy/snell.jpg";
import rudolphSnellImg from "../img/genealogy/rudolph_snell.jpg";
import nabothImg from "../img/genealogy/naboth.jpg";
import erasmusImg from "../img/genealogy/erasmus.jpg";

export const academicGenealogy = [
  {
    name: "Filippos Kokkinos",
    year: "2021",
    school: "UCL",
    field: "Multimodal Foundation Models",
    img: filipposImg,
    url: "https://www.fkokkinos.com"
  },
  {
    name: "Iasonas Kokkinos",
    year: "2006",
    school: "NTUA",
    field: "Computer Vision & Deep Learning",
    img: iasonasImg,
    url: "https://jkokkin.github.io/"
  },
  {
    name: "Petros Maragos",
    year: "1985",
    school: "Georgia Tech",
    field: "Signal & Image Processing, Computer Vision",
    img: maragosImg,
    url: "https://en.wikipedia.org/wiki/Petros_Maragos",
    genealogyId: 18840,
    starred: true
  },
  {
    name: "Ronald W. Schafer",
    year: "1968",
    school: "MIT",
    field: "Digital Signal Processing & Speech Processing",
    img: schaferImg,
    url: "https://en.wikipedia.org/wiki/Ronald_W._Schafer",
    genealogyId: 91056
  },
  {
    name: "Amar Gopal Bose",
    year: "1956",
    school: "MIT",
    field: "Acoustics & Loudspeaker Design (Founder of Bose)",
    img: boseImg,
    url: "https://en.wikipedia.org/wiki/Amar_Bose",
    genealogyId: 82828,
    starred: true
  },
  {
    name: "Norbert Wiener",
    year: "1913",
    school: "Harvard",
    field: "Father of Cybernetics & Stochastic Processes",
    img: wienerImg,
    url: "https://en.wikipedia.org/wiki/Norbert_Wiener",
    genealogyId: 25222,
    starred: true
  },
  {
    name: "Josiah Royce",
    year: "1878",
    school: "Johns Hopkins",
    field: "American Idealism & Mathematical Logic",
    img: royceImg,
    url: "https://en.wikipedia.org/wiki/Josiah_Royce",
    genealogyId: 24410
  },
  {
    name: "George Sylvester Morris",
    year: "1868",
    school: "Univ. of Berlin",
    field: "Hegelian Idealism & History of Philosophy",
    img: morrisImg,
    url: "https://en.wikipedia.org/wiki/George_Sylvester_Morris",
    genealogyId: 95530
  },
  {
    name: "Friedrich Adolf Trendelenburg",
    year: "1826",
    school: "Univ. of Berlin",
    field: "Aristotelian Philosophy & Theory of Categories",
    img: trendelenburgImg,
    url: "https://en.wikipedia.org/wiki/Friedrich_Adolf_Trendelenburg",
    genealogyId: 60803
  },
  {
    name: "Karl Leonhard Reinhold",
    year: "1787",
    school: "Univ. of Jena",
    field: "German Idealism & Kantian Philosophy",
    img: reinholdImg,
    url: "https://en.wikipedia.org/wiki/Karl_Leonhard_Reinhold",
    genealogyId: 35141
  },
  {
    name: "Immanuel Kant",
    year: "1770",
    school: "Univ. of Königsberg",
    field: "Critical Philosophy, Epistemology & Metaphysics",
    img: kantImg,
    url: "https://en.wikipedia.org/wiki/Immanuel_Kant",
    genealogyId: 106921,
    starred: true
  },
  {
    name: "Martin Knutzen",
    year: "1732",
    school: "Univ. of Königsberg",
    field: "Natural Philosophy & Newtonian Physics",
    img: knutzenImg,
    url: "https://en.wikipedia.org/wiki/Martin_Knutzen",
    genealogyId: 106922
  },
  {
    name: "Christian Wolff",
    year: "1703",
    school: "Univ. of Leipzig",
    field: "Enlightenment Philosophy & Mathematics",
    img: wolffImg,
    url: "https://en.wikipedia.org/wiki/Christian_Wolff_(philosopher)",
    genealogyId: 47793
  },
  {
    name: "Gottfried Wilhelm Leibniz",
    year: "1666",
    school: "Univ. of Altdorf",
    field: "Co-inventor of Calculus & Binary Logic",
    img: leibnizImg,
    url: "https://en.wikipedia.org/wiki/Gottfried_Wilhelm_Leibniz",
    genealogyId: 60985,
    starred: true,
    extraLink: {
      text: "FYI: Why was Newton such a jerk?",
      url: "https://www.forbes.com/sites/rosspomeroy/2013/11/04/why-was-isaac-newton-such-a-jerk/"
    }
  },
  {
    name: "Christiaan Huygens",
    year: "1647",
    school: "Univ. of Leiden",
    field: "Wave Theory of Light & Classical Mechanics",
    img: huygensImg,
    url: "https://en.wikipedia.org/wiki/Christiaan_Huygens",
    genealogyId: 125561
  },
  {
    name: "Frans van Schooten, Jr.",
    year: "1635",
    school: "Univ. of Leiden",
    field: "Cartesian Analytic Coordinate Geometry",
    img: schootenImg,
    url: "https://en.wikipedia.org/wiki/Frans_van_Schooten",
    genealogyId: 125450
  },
  {
    name: "Jacobus Golius",
    year: "1621",
    school: "Univ. of Leiden",
    field: "Mathematics, Astronomy & Oriental Studies",
    img: goliusImg,
    url: "https://en.wikipedia.org/wiki/Jacobus_Golius",
    genealogyId: 125408
  },
  {
    name: "Willebrord Snellius",
    year: "1607",
    school: "Univ. of Leiden",
    field: "Optics (Snell's Law of Refraction) & Geodesy",
    img: snellImg,
    url: "https://en.wikipedia.org/wiki/Willebrord_Snellius",
    genealogyId: 125302
  },
  {
    name: "Rudolph Snellius",
    year: "1572",
    school: "Univ. of Marburg",
    field: "Mathematics, Linguistics & Ramist Logic",
    img: rudolphSnellImg,
    url: "https://en.wikipedia.org/wiki/Rudolph_Snellius",
    genealogyId: 125181
  },
  {
    name: "Valentine Naboth",
    year: "1544",
    school: "Univ. of Erfurt",
    field: "Mathematical Astronomy & Calculation",
    img: nabothImg,
    url: "https://en.wikipedia.org/wiki/Valentin_Naboth",
    genealogyId: 125160
  },
  {
    name: "Desiderius Erasmus",
    year: "1506",
    school: "Univ. of Turin",
    field: "Renaissance Humanism & Classical Scholarship",
    img: erasmusImg,
    url: "https://en.wikipedia.org/wiki/Erasmus",
    genealogyId: 125938,
    starred: true
  }
];
